import React from 'react';
import {drawArcPath} from '@di-shared/utils/drawArcPath';

interface VariableDonutChartProps {
  color: string;
  ratio: number;
  width: number;
  strokeWidth: number;
  baseColor?: string;
  angle?: number;
}

/**
 * angle: 도넛 가운데에 파여진 부분 각도의 1/2
 * 범위 1 ~ 180
 */
function VariableDonutChart({
  color,
  ratio,
  width,
  strokeWidth,
  baseColor = 'var(--surface-container-low)',
  angle = 45,
}: VariableDonutChartProps) {
  function drawArcPercentage(ratio: number, radius: number, centerX: number, centerY: number) {
    const startAngle = 90 + angle;
    const endAngle = startAngle + (360 - 2 * angle) * ratio;
    return drawArcPath(startAngle, endAngle, radius, centerX, centerY);
  }

  const radius = width / 2 - strokeWidth / 2;
  const height = width / 2 + strokeWidth / 2 + radius * Math.cos((angle * Math.PI) / 180);
  const centerX = width / 2;
  const centerY = width / 2;

  return (
    <svg
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d={drawArcPercentage(1, radius, centerX, centerY)}
        stroke={baseColor}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
      />
      {!!ratio && (
        <path
          d={drawArcPercentage(ratio, radius, centerX, centerY)}
          stroke={color}
          strokeWidth={strokeWidth}
          strokeLinecap="round"
        />
      )}
    </svg>
  );
}

export default VariableDonutChart;
